import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { OverviewWidgetContainer } from './OverviewWidget';

export const OverviewWidgetWrapper = (props) => {
  const { courseId } = useParams();
  const navigate = useNavigate();

  const onTabChange = (tabName) => {
    let path = `/courses/${courseId}/${tabName}`;
    navigate(path);
  };

  const getLaunchUrl = () => {};

  return (
    <div style={{ maxWidth: '375px' }}>
      <OverviewWidgetContainer
        courseId={courseId}
        onTabChange={onTabChange}
        getLaunchUrl={getLaunchUrl}
        {...props}
      />
    </div>
  );
};
